// extracted by mini-css-extract-plugin
export var container = "_73-0";
export var fallback = "_73-5";
export var fallbackIcon = "_73-6";
export var hidden = "_73-2";
export var image = "_73-3";
export var loaded = "_73-4";
export var placeholder = "_73-1";